import { render, staticRenderFns } from "./PurchaseApproval.vue?vue&type=template&id=641a93ac&scoped=true"
import script from "./PurchaseApproval.vue?vue&type=script&lang=js"
export * from "./PurchaseApproval.vue?vue&type=script&lang=js"
import style0 from "./PurchaseApproval.vue?vue&type=style&index=0&id=641a93ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641a93ac",
  null
  
)

export default component.exports